// Форматирование значений для дашборда статистики по вакансии.
//
// Правила (см. ТЗ):
// - любое числовое поле может быть null → показываем «—», не 0 и не NaN;
// - доли приходят как 0..1 → выводим как проценты;
// - деньги форматируем как «150 000 ₽».

/** Прочерк для отсутствующих значений. */
export const DASH = '—';

/** Узкий type-guard: значение действительно число (не null/undefined/NaN/Infinity). */
export const isNum = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value);

/** Целое число с разделителями разрядов («1 234»). null → «—». */
export const formatCount = (value: number | null | undefined): string =>
  isNum(value) ? Math.round(value).toLocaleString('ru-RU') : DASH;

/** Балл с одним знаком после запятой («7.4»). null → «—». */
export const formatScore = (value: number | null | undefined): string =>
  isNum(value) ? value.toFixed(1) : DASH;

/** Доля 0..1 → проценты («33%»). null → «—». */
export const formatPercent = (ratio: number | null | undefined): string =>
  isNum(ratio) ? `${Math.round(ratio * 100)}%` : DASH;

/** Рубли («150 000 ₽»). null → «—». */
export const formatRub = (value: number | null | undefined): string =>
  isNum(value) ? `${Math.round(value).toLocaleString('ru-RU')} ₽` : DASH;

/**
 * Среднее время отклика в часах: «~14 ч».
 * Возвращает null, если данных нет — вызывающий код просто не рисует подпись.
 */
export const formatAcceptHours = (value: number | null | undefined): string | null => {
  if (!isNum(value)) return null;
  if(value < 1) {
    return `~${Math.round(60 * value)} мин`
  }
  const rounded = value >= 10 ? Math.round(value) : Math.round(value * 10) / 10;
  return `~${rounded} ч`;
};

/** Подпись покрытия под заголовком блока: «оценено 5 из 12». */
export const coverageLabel = (evaluated: number, ofTotal: number): string =>
  `оценено ${formatCount(evaluated)} из ${formatCount(ofTotal)} приглашенных`;
